<!-- Loading state -->
<div *ngIf="loading" class="auth-loading">
  <mat-spinner diameter="40"></mat-spinner>
  <p>Signing you in…</p>
</div>

<!-- Login card — single-column, max-width 480px -->
<mat-card *ngIf="!loading" class="auth-card">
  <mat-card-header>
    <mat-card-title>Welcome back</mat-card-title>
    <mat-card-subtitle>Sign in to your Capiche account</mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>
    <capiche-auth-login-form
      msg="{{ msg }}"
      (formData)="onLogin($event)"
      (studentFormData)="onStudentLogin($event)"
    ></capiche-auth-login-form>

    <button
      *ngIf="showSignInWithGoogle"
      mat-stroked-button
      class="google-btn"
      (click)="onLoginWithGoogle()"
    >
      <mat-icon svgIcon="google-logo" aria-hidden="true"></mat-icon>
      Continue with Google
    </button>

    <p class="legal-text">
      By signing in you agree to our
      <a href="https://www.capiche-limited.com/capiche-app-terms-of-use" target="_blank">Terms of use</a>
      and
      <a href="https://www.capiche-limited.com/privacy-policy" target="_blank">Privacy policy</a>.
    </p>
  </mat-card-content>

  <mat-divider></mat-divider>

  <mat-card-actions class="auth-nav-links">
    <span>New to Capiche? <a [routerLink]="['/register']">Sign up</a></span>
    <span class="nav-sep" aria-hidden="true">·</span>
    <a [routerLink]="['/student-login']">Student login</a>
  </mat-card-actions>
</mat-card>
